<div *ngIf="noteSections.length > 0" [ngClass]="{ 'border p-3': noteWithinTable }">
  <div class="info-panel" *ngFor="let noteSection of noteSections">
    <div style="display: flex">
      <i [ngClass]="noteSection.iconClass || ''">&nbsp;</i>
      <p style="margin: 0" [innerHTML]="noteSection.body || '' | mdToHtml"></p>
    </div>
  </div>
</div>
